declare global {
  interface Window {
    fbq: (...args: any[]) => void
    _fbq: (...args: any[]) => void
  }
}

let initialized = false

export function initMetaPixel(pixelId: string): void {
  if (initialized) return
  if (typeof window === 'undefined') return

  // Meta Pixel base code
  const f = window as any
  const b = document
  const e = 'script'
  const v = 'https://connect.facebook.net/en_US/fbevents.js'

  if (f.fbq) return

  const n: any = (f.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
  })

  if (!f._fbq) f._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []

  const t = b.createElement(e) as HTMLScriptElement
  t.async = true
  t.src = v
  const s = b.getElementsByTagName(e)[0]
  s?.parentNode?.insertBefore(t, s)

  window.fbq('init', pixelId)

  initialized = true
}

export function trackPageView(): void {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'PageView')
  }
}

export function trackAddToCart(): void {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'AddToCart', {
      content_name: 'El Miedo Diario',
      content_type: 'product',
      value: 6.39,
      currency: 'USD',
    })
  }
}
